module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold.woff2
// module id = 276
// module chunks = 0